import React, { useEffect, useRef } from 'react'
import { isNil, size } from 'lodash'
import PropTypes from 'prop-types'

import { showErrorNotification } from '../../../core/helpers'

import { EditableTableRowLoader } from '../../../common/components/sections'

import { useUpdateMenuTitleMutation } from '../../hooks'

const MenuTitleEditableRow = ({ ...rowProps }) => {
  const rowRef = useRef(null)
  const { 'data-row-key': id, children, className, ...restProps } = rowProps

  const [, { isLoading, error }] = useUpdateMenuTitleMutation(
    id?.substring(10, size(id)),
  )

  useEffect(() => {
    if (!isNil(error)) {
      showErrorNotification({
        title: 'Menu title update failed',
        description: error,
      })
    }
  }, [error])

  return (
    <>
      <EditableTableRowLoader
        isLoading={isLoading}
        height={rowRef?.current?.offsetHeight}
      />
      <tr data-row-key={id} ref={rowRef} className={className} {...restProps}>
        {children}
      </tr>
    </>
  )
}

MenuTitleEditableRow.propTypes = {
  rowProps: PropTypes.object,
}

MenuTitleEditableRow.defaultProps = {
  rowProps: undefined,
}

export default MenuTitleEditableRow
